<script setup>
import { onMounted, ref } from 'vue';

defineProps({
    modelValue: {
        required: true,
    },
});

defineEmits(['update:modelValue']);

const input = ref(null);

onMounted(() => {
    if (input.value.hasAttribute('autofocus')) {
        input.value.focus();
    }
});

defineExpose({ focus: () => input.value.focus() });
</script>

<template>
    <input
        class="form__input"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        ref="input"
    />
</template>

<style>
.form__input {
    @apply border-gray-400 border-2 focus:border-[#19868b] focus:ring-[#19868b] px-4 rounded-full shadow-sm;
}
</style>
